import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";

var isCanvasBlacklisted = function isCanvasBlacklisted() {
  if (typeof window === 'undefined') {
    return true;
  }

  var userAgent = window.navigator.userAgent;
  return userAgent.includes('jsdom');
};

var getCanvasContext = function () {
  var canvas = null;
  var context = null;
  var err = isCanvasBlacklisted();
  return function () {
    if (err) {
      return null;
    } // Jest will throw an error on canvas.getContext('2d').
    // We may want to mock this or use a canvas implementation in the future.


    try {
      canvas = canvas || document.createElement('canvas');
      context = context || canvas.getContext('2d');
      return context;
    } catch (e) {
      err = e;
    }

    return null;
  };
}();

var getCanvasFontString = function getCanvasFontString(_ref) {
  var size = _ref.size,
      family = _ref.family,
      weight = _ref.weight;
  return "".concat(weight, " ").concat(size, "px ").concat(family);
};

var getFontWidth = function getFontWidth(_ref2) {
  var text = _ref2.text,
      size = _ref2.size,
      family = _ref2.family,
      weight = _ref2.weight;
  var ctx = getCanvasContext();

  if (!ctx) {
    return 0;
  }

  ctx.font = getCanvasFontString({
    size: size,
    family: family,
    weight: weight
  });
  return ctx.measureText(text).width;
};

var hasFont = function hasFont(_ref3) {
  var family = _ref3.family,
      size = _ref3.size,
      text = _ref3.text,
      weight = _ref3.weight;
  var fallbacks = ['sans-serif', 'serif', 'monospace'];
  return fallbacks.some(function (fallback) {
    var fallbackWidth = getFontWidth({
      text: text,
      size: size,
      family: fallback,
      weight: weight
    });
    var width = getFontWidth({
      text: text,
      size: size,
      family: [family, fallback].join(', '),
      weight: weight
    });
    return width !== fallbackWidth;
  });
};

export var getComputedFont = function getComputedFont(_ref4) {
  var family = _ref4.family,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 128 : _ref4$size,
      _ref4$text = _ref4.text,
      text = _ref4$text === void 0 ? 'Sail' : _ref4$text,
      _ref4$weight = _ref4.weight,
      weight = _ref4$weight === void 0 ? 400 : _ref4$weight;
  var parts = family.split(',').map(function (name) {
    return name.trim().replace(/^"/, '').replace(/"$/, '');
  });
  return parts.find(function (part) {
    return hasFont({
      family: part,
      size: size,
      text: text,
      weight: weight
    });
  }) || '';
};